import { AnyObject } from '@store/types';
import style from './Element.module.scss';

import { ElementWidth } from '@template/store/entryType/types';

const ElementWidthStyle = {
    [ElementWidth.TwoPerLine]: style.elementWidth_6,
    [ElementWidth.ThreePerLine]: style.elementWidth_4,
    [ElementWidth.FourPerLine]: style.elementWidth_3,
};

const ElementWidthStyleReport = {
    [ElementWidth.OnePerLine]: 'OnePerLineField',
    [ElementWidth.AnotherOnePerLine]: 'OnePerLineField',
    [ElementWidth.TwoPerLine]: 'TwoPerLineField',
    [ElementWidth.ThreePerLine]: 'ThreePerLineField',
    [ElementWidth.FourPerLine]: 'FourPerLineField',
};

export function getElementWidth(elementWidth?: ElementWidth): string | undefined {
    return elementWidth ? (ElementWidthStyle as AnyObject)[elementWidth] : undefined;
}

export function getElementWidthReport(elementWidth?: ElementWidth): string | undefined {
    return elementWidth ? ElementWidthStyleReport[elementWidth] : (ElementWidthStyleReport as AnyObject)[0];
}
